import { useTranslation } from "react-i18next"
import { Outlet, useLocation } from "react-router-dom"
import { useAppSelector } from "store/index"
import { AppSelectors } from "store/slices/appSlice"
import { useModal } from "context/ModalsContext"
import { APP_ROUTES } from "utils/app-routes"
import Balance from "ui/balance"
import SideMenu from "ui/sideMenu"
import { Profile } from "ui/profile"
import { FooterMenu } from "ui/footerMenu"
import LeftSideMenu from "ui/leftSideMenu"
import type { ISideMenuItem } from "ui/sideMenu/ui/side-menu-item"
import { bossInventoryIcon, bossShopIcon } from "assets/icons"

const DefaultTemplate = () => {
  const { t } = useTranslation()
  const { modals } = useModal()
  const isUnder = useAppSelector(AppSelectors.selectIsUnder())

  const darkSideMenuItems: ISideMenuItem[] = [
    {
      name: "inventory",
      title: t("inventory"),
      color: "#B9A0BA",
      icon: bossInventoryIcon,
      link: "/inventory"
    },
    {
      name: "tonShop",
      title: t("store"),
      color: "#B9A0BA",
      icon: bossShopIcon,
      link: "/ton-shop"
    }
  ]

  const renderProfilePathnames = ["/", "/home", "/jail"]
  const renderSideMenuPathnames = ["/", "/home"]
  const renderFooterMenuPathnames = [
    "/",
    "/jail",
    "/hero",
    "/hero/training",
    "/hero/professions",
    "/hero/achievements",
    "/inventory",
    "/ton-shop",
    APP_ROUTES.STORE,
    APP_ROUTES.STORE_TON,
    APP_ROUTES.OFFERS,
    APP_ROUTES.AUCTION,
    APP_ROUTES.AUCTION_HISTORY,
    "/inventory/craft",
    "/referrals",
    "/referrals/details",
    "/referrals/commissions",
    "/referrals/friends",
    "/wallet",
    "/wallet/buy-gold",
    "/wallet/deposit",
    "/wallet/withdrawal",
    "/wallet/balance-history",
    "/wallet/staking",
    "/wallet/staking/active-plans"
  ]

  const location = useLocation()
  const { pathname } = location

  if (modals.createDogName) return <Outlet />

  const showSideMenus = renderSideMenuPathnames.includes(pathname)

  return (
    <>
      {renderProfilePathnames.includes(pathname) && <Profile />}
      <Balance isLowered={renderProfilePathnames.includes(pathname)} />
      {showSideMenus && !isUnder && <SideMenu />}
      {showSideMenus && isUnder && <SideMenu items={darkSideMenuItems} />}
      {showSideMenus && <LeftSideMenu />}
      {renderFooterMenuPathnames.includes(pathname) && <FooterMenu />}
      <Outlet />
    </>
  )
}

export default DefaultTemplate
